<p class="title">
  Ticket als e-mail versturen
</p>
<form [formGroup]="mailForm" (ngSubmit)="sendEmail()" novalidate>
  <ion-item lines="full">
    <ion-input label="E-mail" (keyup.enter)="sendEmail()" [(ngModel)]="emailAddress" formControlName="email"
      type="email" required></ion-input>
  </ion-item>
  <div class="action-buttons">
    <ion-button type="submit" disabled="{{isSubmitted}}">Verzend e-mail</ion-button>
  </div>
</form>